import { useForm } from "react-hook-form";
import withAuthLayout from "../../hoc/withAuthLayout";
import { yupResolver } from "@hookform/resolvers/yup";
import { forgotPasswordValidation } from "../../utils/validations/formValidations";
import EmailIcon from "../../assets/email.svg";
import BackIcon from "../../assets/back.svg";
import { useNavigate } from "react-router-dom";
import AuthContainer from "../../components/ui/AuthContainer";
import { ForgotPass } from "../../utils/api";
import { message } from "antd";
import { useState } from "react";
import { setInLocalStorage } from "./../../utils/storageUtil";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(forgotPasswordValidation) });

  const onSubmit = async (data) => {
    const forgotPassData = {
      email: data.email,
      authMethod: "email",
      deviceType: "web",
      deviceId: "123",
    };

    try {
      setLoading(true);
      const resData = await ForgotPass(forgotPassData);
      if (resData?.isSuccess) {
        setInLocalStorage("isEmailVerified", true);
        setLoading(false);
        navigate("/auth/verify", { state: resData?.data?.id });
      } else {
        message.destroy();
        message.error(resData?.message);
        setLoading(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      message.error("An error occurred during login. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContainer>
      <div
        className="pb-4 flex gap-x-2 items-center cursor-pointer"
        onClick={() => navigate("/auth/login")}
      >
        <img src={BackIcon} width={15} alt="back-arrow" />
        <span className="text-[13px] 2xl:text-lg font-medium text-black-700">
          Back
        </span>
      </div>
      <h2 className=" font-bold text-base heading">Forgot Password</h2>
      <h4 className="2xl:text-base font-semibold text-xs">
        Enter your email to recover the password.
      </h4>
      <p className="text-[12px] 2xl:text-base text-input-placeholder">
        we have sent a password recover instruction to your email.
      </p>
      <form
        className="flex flex-col"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <div className="2xl:p-4 border border-input-placeholder flex items-center gap-x-2 rounded-lg p-3 relative mt-2">
          <label
            className="2xl:text-sm absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1"
            htmlFor="email"
          >
            Email
          </label>
          <img src={EmailIcon} alt="email-svg" width={12} />
          <input
            placeholder="michellejohnson125@gmail.com"
            className="w-full outline-none text-[12px] text-input-placeholder"
            type="email"
            id="email"
            {...register("email")}
          />
        </div>
        <p className="text-[red] text-[12px]">{errors.email?.message}</p>
        <button
          type="submit"
          className="sign-in mt-6 bg-[#E5B3B2] w-max mx-auto text-white text-[10px] px-12 py-3 rounded-lg flex items-center gap-x-2"
        >
          <span>Submit</span>
          {loading && <span className="loader"></span>}
        </button>
      </form>
    </AuthContainer>
  );
};

export default withAuthLayout(ForgotPassword);
